import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledVerticalForm = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'withBorder' && prop !== 'borderRadius',
})(({ theme, borderRadius, withBorder = true }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '25px',
  paddingTop: '30px',
  paddingBottom: withBorder ? '30px' : '0',
  backgroundColor: 'white',
  borderBottom: withBorder ? '1px solid #ccc' : 'none',
  overflowX: 'auto',
  maxWidth: '100%',

  ...(borderRadius && {
    borderBottomRightRadius: '5px',
    borderBottomLeftRadius: '5px',
  }),

  [theme.breakpoints.down('md')]: {
    padding: '20px',
    paddingTop: '25px',
    paddingBottom: '25px',
  },

  [theme.breakpoints.down('sm')]: {
    padding: '15px',
    paddingTop: '20px',
    paddingBottom: '20px',
  },

  [theme.breakpoints.down('xs')]: {
    padding: '10px',
    paddingTop: '15px',
    paddingBottom: '15px',
  },
}));

const VerticalForm = ({ children, sx = {}, ...props }) => {
  return (
    <StyledVerticalForm sx={sx} {...props}>
      {children}
    </StyledVerticalForm>
  );
};

export default VerticalForm;
